module.exports = require('./lib/internals')



//////////////////
// WEBPACK FOOTER
// /opt/build/repo/node_modules/@sanity/block-content-to-hyperscript/internals.js
// module id = 218
// module chunks = 6